import React from "react";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

/** Single-choice list filter that can be cleared on its own. "" = none. */
export default function FilterSelect({
  value,
  onChange,
  options,
  allLabel,
  placeholder,
  width = "w-[180px]",
  className,
}) {
  const active = !!value;
  return (
    <div className={cn("relative inline-flex", className)}>
      <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
        <SelectTrigger
          className={cn(
            "h-9 bg-white border-gray-300 text-sm",
            width,
            active && "border-[#7f7ad5] pr-8 [&>svg]:hidden"
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{allLabel}</SelectItem>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {active && (
        <button
          type="button"
          aria-label={`Clear ${placeholder}`}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          onClick={() => onChange("")}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
